import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import api from '../lib/api';
import { formatDate } from '../lib/format';

export default function Availability() {
  const [avail, setAvail] = useState({});
  const [month, setMonth] = useState(new Date());
  useEffect(() => { api.get('/availability').then(r => setAvail(r.data)); }, []);

  const y = month.getFullYear(), m = month.getMonth();
  const first = new Date(y, m, 1);
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  const offset = first.getDay();
  const cells = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const monthName = first.toLocaleString('en-GB', { month: 'long', year: 'numeric' });

  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-3xl mx-auto">
      <div className="eyebrow">Calendar</div>
      <h1 className="serif text-[28px] mb-5">Availability</h1>

      <div className="card-cream p-5">
        <div className="flex items-center justify-between mb-4">
          <button onClick={() => setMonth(new Date(y, m-1, 1))} data-testid="cal-prev"><ChevronLeft/></button>
          <div className="serif text-[20px]">{monthName}</div>
          <button onClick={() => setMonth(new Date(y, m+1, 1))} data-testid="cal-next"><ChevronRight/></button>
        </div>
        <div className="grid grid-cols-7 gap-1 text-center text-[10px] uppercase tracking-[0.14em] text-[var(--muted)] mb-2">
          {['S','M','T','W','T','F','S'].map((d,i) => <div key={i}>{d}</div>)}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {cells.map((d, i) => {
            if (!d) return <div key={i} className="aspect-square"/>;
            const iso = `${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
            const state = avail[iso];
            const bg = state?.state === 'confirmed' ? 'rgba(107,143,113,0.25)' : state?.state === 'tentative' ? 'rgba(200,151,63,0.20)' : 'transparent';
            const border = state?.state === 'confirmed' ? 'var(--ok)' : state?.state === 'tentative' ? 'var(--pending)' : 'var(--line)';
            return (
              <div key={i} className="aspect-square rounded flex flex-col items-center justify-center text-xs" style={{background: bg, border:`1px solid ${border}`}} title={state ? `${state.state} — ${state.project_name}` : 'Free'} data-testid={`cal-${iso}`}>
                <div>{d}</div>
                {state && <div className="text-[9px] tracking-[0.1em] uppercase mt-0.5" style={{color: state.state==='confirmed'?'var(--ok)':'var(--pending)'}}>{state.state.slice(0,4)}</div>}
              </div>
            );
          })}
        </div>
        <div className="flex gap-4 text-[10px] tracking-[0.14em] uppercase text-[var(--muted)] mt-4">
          <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded" style={{background:'rgba(107,143,113,0.25)', border:'1px solid var(--ok)'}}/> Confirmed</span>
          <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded" style={{background:'rgba(200,151,63,0.20)', border:'1px solid var(--pending)'}}/> Tentative</span>
          <span className="flex items-center gap-1"><span className="inline-block w-3 h-3 rounded" style={{border:'1px solid var(--line)'}}/> Free</span>
        </div>
      </div>
    </div>
  );
}
